// Elite Relógios · Noite, 3ª rodada (14/10/2026).
// Mostrador guilloché da abertura com luz pontual, vitrine em carrossel, passos que acendem, "Mandar" e barra do celular no produto.
(() => {
  const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Mostrador guilloché (abertura) ----------
  // O desenho segue o símbolo da IDV: lua crescente acesa à esquerda e a rosácea dentro do círculo menor.
  // Duas camadas: uma apagada (sempre à mostra) e uma acesa, que só aparece dentro do círculo de luz.
  const desenhar = (ctx, S, cor, lw) => {
    const c = S / 2;
    const R = S * 0.47;
    const cx2 = c + R * 0.179; // centro do círculo de dentro (mesma proporção do símbolo)
    const Ri = R * 0.769;
    const circulo = (x, y, r) => { ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.stroke(); };
    ctx.strokeStyle = cor;
    ctx.lineWidth = lw;

    // lua: linhas concêntricas gravadas, só na faixa da lua
    ctx.save();
    ctx.beginPath();
    ctx.arc(c, c, R, 0, Math.PI * 2);
    ctx.arc(cx2, c, Ri, 0, Math.PI * 2, true);
    ctx.clip();
    const passo = Math.max(3, S / 240);
    for (let r = R * 0.55; r <= R; r += passo) circulo(c, c, r);
    ctx.restore();

    // aros
    circulo(c, c, R);
    circulo(cx2, c, Ri * 0.985);
    circulo(cx2, c, Ri * 0.95);

    // rosácea grande (60 círculos) e faixa fina (120 círculos), como o torno grava
    for (let i = 0; i < 60; i++) {
      const a = (i / 60) * Math.PI * 2;
      circulo(cx2 + Math.cos(a) * Ri * 0.46, c + Math.sin(a) * Ri * 0.46, Ri * 0.46);
    }
    ctx.save();
    ctx.globalAlpha *= 0.7;
    for (let i = 0; i < 120; i++) {
      const a = (i / 120) * Math.PI * 2;
      circulo(cx2 + Math.cos(a) * Ri * 0.71, c + Math.sin(a) * Ri * 0.71, Ri * 0.2);
    }
    ctx.restore();
    circulo(cx2, c, Ri * 0.035);
  };

  const mostrador = (canvas) => {
    const caixa = canvas.parentElement;
    const secao = canvas.closest('.elite-mostrador');
    const ctx = canvas.getContext('2d');
    const apagada = document.createElement('canvas');
    const acesa = document.createElement('canvas');
    const mascara = document.createElement('canvas');
    let S = 0;
    let luz = { x: 0, y: 0 };
    let alvo = { x: 0, y: 0 };
    let ultimoMouse = 0;
    let angulo = 2.4;
    let visivel = true;
    let quadro = 0;

    const preparar = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const lado = caixa.clientWidth;
      if (!lado) return;
      S = Math.min(Math.round(lado * dpr), 2400);
      [canvas, apagada, acesa, mascara].forEach((cv) => { cv.width = S; cv.height = S; });
      const fio = Math.max(1, S / 1100);
      const a = apagada.getContext('2d');
      a.clearRect(0, 0, S, S);
      desenhar(a, S, 'rgba(201,169,110,0.2)', fio);
      const b = acesa.getContext('2d');
      b.clearRect(0, 0, S, S);
      desenhar(b, S, '#efdcb2', fio * 1.15);
      if (!luz.x) { luz = { x: S * 0.3, y: S * 0.34 }; alvo = { ...luz }; }
      pintar();
    };

    const pintar = () => {
      ctx.clearRect(0, 0, S, S);
      // brilho largo e quente embaixo da luz
      const brilho = ctx.createRadialGradient(luz.x, luz.y, 0, luz.x, luz.y, S * 0.42);
      brilho.addColorStop(0, 'rgba(201,169,110,0.10)');
      brilho.addColorStop(1, 'rgba(201,169,110,0)');
      ctx.fillStyle = brilho;
      ctx.fillRect(0, 0, S, S);
      ctx.drawImage(apagada, 0, 0);
      const m = mascara.getContext('2d');
      m.globalCompositeOperation = 'source-over';
      m.clearRect(0, 0, S, S);
      m.drawImage(acesa, 0, 0);
      m.globalCompositeOperation = 'destination-in';
      const g = m.createRadialGradient(luz.x, luz.y, 0, luz.x, luz.y, S * 0.26);
      g.addColorStop(0, 'rgba(0,0,0,1)');
      g.addColorStop(0.35, 'rgba(0,0,0,0.55)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      m.fillStyle = g;
      m.fillRect(0, 0, S, S);
      ctx.drawImage(mascara, 0, 0);
    };

    const rodar = (t) => {
      quadro = 0;
      if (!visivel || document.hidden) return;
      // sem mouse por 2,5 s (ou no celular), a luz passeia sozinha pela lua e pela rosácea
      if (t - ultimoMouse > 2500) {
        angulo += 0.0045;
        alvo = { x: S * (0.5 + Math.cos(angulo) * 0.27), y: S * (0.5 + Math.sin(angulo) * 0.24) };
      }
      luz.x += (alvo.x - luz.x) * 0.07;
      luz.y += (alvo.y - luz.y) * 0.07;
      pintar();
      quadro = requestAnimationFrame(rodar);
    };
    const ligar = () => { if (!semMovimento && !quadro) quadro = requestAnimationFrame(rodar); };

    preparar();
    if (semMovimento) return;
    secao.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = canvas.getBoundingClientRect();
      alvo = { x: ((e.clientX - r.left) / r.width) * S, y: ((e.clientY - r.top) / r.height) * S };
      ultimoMouse = performance.now();
    });
    new IntersectionObserver(([e]) => { visivel = e.isIntersecting; if (visivel) ligar(); }).observe(secao);
    document.addEventListener('visibilitychange', ligar);
    let espera;
    window.addEventListener('resize', () => { clearTimeout(espera); espera = setTimeout(preparar, 150); });
    ligar();
  };

  // ---------- Vitrine: uma peça por vez (15/10/2026) ----------
  const cena = (raiz) => {
    const slides = [...raiz.querySelectorAll('[data-elite-slide]')];
    const nomes = [...raiz.querySelectorAll('[data-elite-ir]')];
    const barra = raiz.querySelector('[data-elite-progresso]');
    const contador = raiz.querySelector('[data-elite-contador]');
    if (!slides.length) return;
    let i = 0;
    const ir = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle('is-ativa', on);
        if (on) s.removeAttribute('hidden');
        else s.setAttribute('hidden', '');
      });
      nomes.forEach((b, k) => {
        const on = k === i;
        b.classList.toggle('is-ativa', on);
        if (on) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
      if (contador) contador.textContent = `${i + 1} / ${slides.length}`;
      if (barra) barra.style.transform = `scaleX(${(i + 1) / slides.length})`;
    };
    raiz.querySelector('[data-elite-anterior]')?.addEventListener('click', () => ir(i - 1));
    raiz.querySelector('[data-elite-proximo]')?.addEventListener('click', () => ir(i + 1));
    nomes.forEach((b) => b.addEventListener('click', () => ir(Number(b.dataset.eliteIr))));
    raiz.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); ir(i - 1); }
    });
    ir(0);
  };

  // ---------- Abas da ficha (mostrador, caixa, movimento) ----------
  const abas = (raiz) => {
    const botoes = [...raiz.querySelectorAll('[role="tab"]')];
    const abrir = (id) => {
      botoes.forEach((b) => {
        const on = b.getAttribute('aria-controls') === id;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      raiz.querySelectorAll('[role="tabpanel"]').forEach((p) => { p.hidden = p.id !== id; });
    };
    raiz.addEventListener('click', (e) => {
      const b = e.target.closest('[role="tab"]');
      if (b && raiz.contains(b)) abrir(b.getAttribute('aria-controls'));
    });
    raiz.addEventListener('keydown', (e) => {
      const atual = botoes.indexOf(document.activeElement);
      if (atual < 0) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      const n = e.key === 'ArrowRight' ? (atual + 1) % botoes.length : (atual - 1 + botoes.length) % botoes.length;
      botoes[n].focus();
      abrir(botoes[n].getAttribute('aria-controls'));
    });
  };

  // ---------- Passos: o fio desce com a rolagem e cada passo acende ----------
  const passos = (lista) => {
    const fio = lista.querySelector('[data-elite-fio]');
    const itens = [...lista.querySelectorAll('.elite-passo')];
    if (semMovimento || !fio) { itens.forEach((li) => li.classList.add('is-aceso')); if (fio) fio.style.transform = 'scaleY(1)'; return; }
    const medir = () => {
      const r = lista.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (window.innerHeight * 0.62 - r.top) / r.height));
      fio.style.transform = `scaleY(${p})`;
      itens.forEach((li) => li.classList.toggle('is-aceso', li.offsetTop + li.offsetHeight * 0.4 <= p * lista.offsetHeight));
    };
    let pedido = 0;
    window.addEventListener('scroll', () => { if (!pedido) pedido = requestAnimationFrame(() => { pedido = 0; medir(); }); }, { passive: true });
    medir();
  };

  // ---------- Barra presa no celular (produto) ----------
  const ilha = () => {
    if (!document.querySelector('[data-elite-ilha]')) return;
    let pedido = 0;
    const medir = () => {
      pedido = 0;
      const botao = document.querySelector('[data-elite-compra]');
      const barra = document.querySelector('[data-elite-ilha]');
      if (!botao || !barra) return;
      const r = botao.getBoundingClientRect();
      const mostrar = window.innerWidth < 750 && r.bottom < 0;
      barra.classList.toggle('is-visivel', mostrar);
      barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      barra.querySelector('a')?.setAttribute('tabindex', mostrar ? '0' : '-1');
    };
    window.addEventListener('scroll', () => { if (!pedido) pedido = requestAnimationFrame(medir); }, { passive: true });
    medir();
  };

  // ---------- "Mandar": copiar o link ----------
  document.addEventListener('click', async (e) => {
    const botao = e.target.closest?.('[data-elite-copiar]');
    if (!botao) return;
    const texto = botao.querySelector('[data-elite-copiar-texto]');
    try {
      await navigator.clipboard.writeText(botao.dataset.eliteCopiar);
      if (texto) { texto.textContent = 'Link copiado'; setTimeout(() => { texto.textContent = 'Copiar o link'; }, 2200); }
    } catch (erro) {
      if (texto) texto.textContent = 'Não deu para copiar';
    }
  });

  const iniciar = (raiz = document) => {
    raiz.querySelectorAll('[data-elite-guilloche]').forEach(mostrador);
    raiz.querySelectorAll('[data-elite-carrossel]').forEach(cena);
    raiz.querySelectorAll('[data-elite-abas]').forEach(abas);
    raiz.querySelectorAll('[data-elite-passos]').forEach(passos);
  };
  const tudo = () => { iniciar(); ilha(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo);
  else tudo();
  // no editor do tema, a seção é trocada sem recarregar a página
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
